__turbopack_context__.v({
  "backBtn": "_AuthCallback-module-scss-module___JgZRa__backBtn",
  "card": "_AuthCallback-module-scss-module___JgZRa__card",
  "cardBody": "_AuthCallback-module-scss-module___JgZRa__cardBody",
  "errorCardBody": "_AuthCallback-module-scss-module___JgZRa__errorCardBody",
  "errorCode": "_AuthCallback-module-scss-module___JgZRa__errorCode",
  "errorDescription": "_AuthCallback-module-scss-module___JgZRa__errorDescription",
  "errorIcon": "_AuthCallback-module-scss-module___JgZRa__errorIcon",
  "errorIconWrap": "_AuthCallback-module-scss-module___JgZRa__errorIconWrap",
  "errorPanel": "_AuthCallback-module-scss-module___JgZRa__errorPanel",
  "errorTitle": "_AuthCallback-module-scss-module___JgZRa__errorTitle",
  "page": "_AuthCallback-module-scss-module___JgZRa__page",
  "shell": "_AuthCallback-module-scss-module___JgZRa__shell",
  "spinWrap": "_AuthCallback-module-scss-module___JgZRa__spinWrap",
  "subtitle": "_AuthCallback-module-scss-module___JgZRa__subtitle",
  "title": "_AuthCallback-module-scss-module___JgZRa__title",
});
